var _circle, _circle2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateRegistry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 16,
    height: 16,
    fill: "url(#state-registry)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "state-registry",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9527_83109",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9527_83109",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACQElEQVR4nO3ZsWpUQRjF8TNGE4mVpa2FQrBRIYoKpvAp7CK+gKTSF7DxORS0USy1iKXY2wja2QqKJGvzt9hcWKLuZs3unNm751ff5fvud5jdmR0pIiIiIiIiIiJiAQAXgdfAD+A78Aq44O5rKQDXgT3+tAdcc/fXa8AK8OUvw+98Bk65++wt4MaY4XfuuPvsNWBrzPC33P0d1Ql3A8suAZglALOT7gamBZyRdFvS3TGP3QfWJb0rpfys01nPHez7XwCDI+yAOoODz+Rc8L+ADWB3iqH/yy6w4X6fhcHwsPUI2J/B8Dv7wENgxf1+TQNWgeczHPxhL4HT7vdsErAOvJ3j8DtvGP5QxyjgWYXhd56637cpwE7F4XceON+5OIuPAs5L+ihprXLpX5IulVI+Va4rqa2T8BPVH74krUp6bKgrqZEVAGxKem9uY7OU8qF20VZWwD13A5K2HUXtK4DhfvyrpLPmVr5JOldKGdQs2sIKuCX/8KVhDzdrF20hgCvuBkZcrV2whQAuuxsYUb2X6r8BALVrHkcpZa4zamEFLLUEYJYAIiIiTOZ+Dli0ff8ksz4XZBdklgDMEoBZc/8FHf6Obe35WcsKMEsAZgnALAGYJQCzBGCWAMwSgFkCMEsAZgkgIiLCZOr/uvt2xztvk+4TsgsySwBmCcDs2Pedrd3Ztvb8JFkBZgnALAGYJQCzBGCWAMwSgFkCMEsAZgnALAGYJQCzBGCWAMwSgFnuhOcsd8KNSwBmCSAiIiIiIqKy397MksM4NIbMAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateRegistry);
export default __webpack_public_path__ + "static/media/state-registry.a3f9f52fae80dfee2a4897098556e077.svg";
export { ForwardRef as ReactComponent };